<template>
  <div>
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 text-sm text-gray-700 dark:text-gray-300">
      <div>
        <!-- <p class="mb-1">{{ $t('overall_progress') }}: <strong>{{ assignedTo ? assignedTo.entityName : '-' }}</strong></p> -->
        <p class="mb-1">{{ $t('overall_progress') }}: <strong>{{ $t('pictogram') }}</strong></p>
        <div class="flex items-center gap-4">
          <!-- <progress-circle :progress="4" class="w-16 h-16"></progress-circle> -->
          <progress-spinner :progress="progressOverall" class="w-16 h-16"></progress-spinner>
          <span class="text-lg font-medium">{{ progressOverall }}%</span>

        </div>
        <div class="flex gap-2">
          <p class="flex items-center gap-1 mt-2 text-green-600 dark:text-green-400">
            {{ assignedTo ? assignedTo.entityType : '-' }}
          </p>
          <p class="text-right">
            <b-button
              type="is-primary"
              size="is-small"
              class="mt-2"
              :loading="recalculating"
              :disabled="recalculating"
              @click="$emit('epc-recalculate')"
              icon-right="calculator"
              icon-pack="fas" />
          </p>
        </div>
      </div>

      <div v-for="layer in pictogram.layers" :key="'lyr-p-s_' + layer.code">
        <p class="mb-1">{{ $t('layer') }}: <strong>{{ $te(layer.code) ? $t(layer.code) : layer.name }}</strong></p>
        <p class="mb-1">{{ $t('weight') }}: <strong>{{ layer.weight }}</strong></p>
        <p class="text-lg font-medium">{{ _GetAdvance(layer.metadata, 'normalize') }}% de 100 {{ $t('completed') }}</p>
        <div class="flex items-center gap-2">
          <segmented-progress-bar :progress="_GetAdvance(layer.metadata, 'normalize')" :total-segments="5"></segmented-progress-bar>
        </div>
        <p class="text-right">
          <b-button
            type="is-primary"
            size="is-small"
            class="mt-2"
            @click="_ShowProgressSummaryLayer(layer)"
            icon-right="traffic-light"
            icon-pack="fas" />
        </p>
      </div>

      <!-- <div>
        <p class="mb-1">Project cost: <strong>Within budget</strong></p>
        <p class="text-gray-600 dark:text-gray-400">2 February</p>
        <p class="text-red-600 dark:text-red-400 font-semibold">-$4500</p>
      </div>

      <div>
        <p class="mb-1">Time spent: <strong>Slightly behind</strong></p>
        <div class="space-y-1">
          <p><span class="font-medium">Total hours:</span> 56h 1m</p>
          <p><span class="font-medium">Days:</span> 18</p>
        </div>
      </div> -->
    </div>

    <progress-summary-modal ref="refProgressSummaryModal"
    />
  </div>
</template>

<script>
import ProgressSpinner from './progress-spinner.vue';
import ProgressCircle from './progress-circle.vue';
import SegmentedProgressBar from './segmented-progress-bar.vue';
import ProgressSummaryModal from './progress-summary-modal.vue';

import { getProgressLayerFromMetadata } from '../../services/helpers.service';

export default {
  components: {
    ProgressSpinner,
    ProgressCircle,
    SegmentedProgressBar,
    ProgressSummaryModal,
  },

  name: 'ProgressSummary',

  props: {
    pictogram: {
      type: Object,
      required: true
    },
    assignedTo: {
      type: Object,
      default: null
    },
    // el recálculo lo gestiona el padre (pictogram-admin-panel) para tener una sola
    // fuente de verdad y el overlay a nivel de todo el panel; aquí solo reflejamos el estado.
    recalculating: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isLoading: false,

      progressOverall: 0,
    };
  },

  watch: {
    // immediate: el padre rellena `assignedTo` ANTES de que este componente monte
    // (está detrás de un v-if mientras carga el pictograma), así que sin `immediate`
    // el watcher no dispararía para el valor inicial y el progreso quedaría en 0.
    assignedTo: {
      immediate: true,
      handler (newValue) {
        if (newValue && newValue.progress !== undefined) {
          this.progressOverall = parseFloat(newValue.progress);
        } else {
          this.progressOverall = 0;
        }
      }
    }
  },

  methods: {
    _GetAdvance(metadata, type=null) {
      return getProgressLayerFromMetadata(metadata, type)
    },

    _ShowProgressSummaryLayer(layer) {
      this.$refs.refProgressSummaryModal.show(layer)
    },
  }
};
</script>
